export const simulationDateFormat = 'YYYY-MM-DDTHH:mm:ss.SSS';
